module.exports = __webpack_public_path__ + "img/IMG_2368_L_Foamcore.b1b62311.jpg";